import React from 'react';
import styled from 'styled-components';
import { Spin } from 'clad';

const LoadingOverlayWrap = styled.div`
    position: absolute;
    height: 100%;
    width: 100%;
    z-index: 200;
    background: #fff;
    opacity: 0.6;
    .loading-overlay-spinner {
        position: absolute;
        left: 50%;
        top: 50%;
        -webkit-transform: translate(-50%, -50%);
        transform: translate(-50%, -50%);
    }
`;

const LoadingOverlay = () => {
    return (
        <LoadingOverlayWrap>
            <Spin size="large" className="loading-overlay-spinner" />
        </LoadingOverlayWrap>
    );
};

export default LoadingOverlay;
